import i18n from "config/i18next";

i18n.addResources("es", "filterTemplates", {
  codeLabel: "Código",
  codePlaceholder: "Ingresá el código",
  regionLabel: "Región",
  regionPlaceholder: "Seleccioná la región",
  workzoneLabel: "Zona de operación",
  workzonePlaceholder: "Seleccioná la zona",
  shiftLabel: "Horario",
  shiftPlaceholder: "Seleccioná el turno",
  frequencyLabel: "Frecuencia",
  frequencyPlaceholder: "Seleccioná la frecuencia",
  invalidCodeError: "El código ingresado es erróneo",
});
